<template>
  <image-tile
    @click.native="tileClicked(spaceplan.id)"
    v-bind:class="[{ clicked: isActive }]"
  >
    <template v-slot:image>
      <img alt="vizualization image" class="img-fluid" :src="spaceplan.image" />
    </template>

    <template v-slot:line1>
      {{ spaceplan.name }}
    </template>
  </image-tile>
</template>

<script>
import ImageTile from '@/components/utils/tiles/ImageTile';

export default {
  name: 'SpacePlanTile',
  components: { ImageTile },
  props: {
    spaceplan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    tileClicked(spaceplanId) {
      this.animateTileClick();
      this.$router.push({
        name: 'spaceplan',
        params: { id: spaceplanId },
      });
    },
    animateTileClick() {
      this.isActive = true;
      setTimeout(() => {
        this.isActive = false;
      }, 200);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
